




















import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import All from '@/components/All.vue';
import SingleAvatar from '@/components/SingleAvatar.vue';
import Editor from '@/components/Editor.vue';
import { db } from '@/firebase';
import { defaultCustomProperties } from '@/custom-properties';

@Component({
    components: {
        Editor,
        All,
        SingleAvatar
    }
})
export default class App extends Vue {
    mode: any = 'design';

    character = 'A';

    setName = 'abstract-avatars';

    customProperties: any = defaultCustomProperties;

    @Watch('customProperties', {
        deep: true,
        immediate: true
    })
    customPropertiesChange(value: any) {
        const root = document.documentElement;
        const keys = Object.keys(value);

        keys.forEach((key: string) => {
            if (key.indexOf('-') === 0) {
                root.style.setProperty(key, value[key]);
            }
        });
    }

    async created() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('mode')) {
            this.mode = params.get('mode');
        }

        if (this.mode === 'all' || this.mode === 'single') {
            const configuration = await db
                .collection('configurations')
                .doc(params.get('id') ?? '')
                .get();

            const data = configuration.data();

            if (data) {
                const { signature, setName = '', ...customProperties } = data;
                this.setName = setName;
                Object.keys(customProperties)
                    .sort()
                    .map((key: string) => {
                        if (this.customProperties[key]) {
                            this.customProperties[key] = customProperties[key];
                        }
                    });
            }
        }

        if (params.has('character')) {
            this.character = params.get('character') as string;
        }
    }
}
